module.exports = __webpack_public_path__ + "static/MBI-ce9b9503575f5fbdfa4698b25cd3173e.jpg";